import {zfd} from "zod-form-data";
import {z} from "zod";
import { MAX_COMMENT_LENGTH, MIN_COMMENT_LENGTH } from "@/@core/constants/comments";

/**
 * Built from the caller's `t`. A module-scope schema is evaluated on import,
 * where there is no request and therefore no translator — which is why these
 * messages stayed out of Weblate while the rest of the app moved over.
 */
type Translate = (key: string, options?: Record<string, any>) => string;

export const listpageCommentSchema = (t: Translate) =>
    zfd.formData({
        serviceId: z.string().optional(),
        districtId: z.string().optional(),
        fullName: z
            .string()
            .min(2, { message: t("comment-form-title-min-length-warning") })
            .max(70, { message: t("comment-form-title-max-length-warning") })
            .refine((val) => val.trim().split(/\s+/).length >= 2, {
                message: t("form-fullname-required-warning"),
            }),
        comment: z
            .string()
            .min(MIN_COMMENT_LENGTH, {
                message: t("comment-form-comment-min-length-warning", {
                    min: MIN_COMMENT_LENGTH,
                }),
            })
            .max(MAX_COMMENT_LENGTH, {
                message: t("comment-form-comment-max-length-warning", {
                    max: MAX_COMMENT_LENGTH,
                }),
            }),
        rating: z
            .number()
            .min(1, { message: t("comment-form-rating-min-warning") })
            .max(5, { message: t("comment-form-rating-max-warning") }),
        phone: z
            .string()
            .max(15, { message: t("comment-form-phone-max-length-warning") })
            .optional(),
        instagram_username: z
            .string()
            .max(50, {
                message: t("comment-form-instagram-username-max-length-warning"),
            })
            .optional(),
        address: z
            .string()
            .max(200, { message: t("contest-address-max-length-warning") })
            .optional(),
        email: z
            .string()
            .email({ message: t("comment-form-email-invalid-warning") })
            .max(100, { message: t("contest-email-max-length-warning") })
            .optional(),
    })
